import React from 'react';
import { render } from '@wordpress/element';
import './index.css';
import Against from './components/Against';
import { UserProvider } from './context/context';
import StaticImage from './components/StaticImage';
import InFavor from './components/InFavor';

const PostGayMarriageChangingOpinions = () => {
    return (
        <UserProvider>
            <div id="interactive" class="w660">
                <StaticImage />
                <InFavor />
                <Against />
            </div>
        </UserProvider>
    );
};

if (document.getElementById('js-post-gay-marriage-changing-opinions')) {
    render(
        <PostGayMarriageChangingOpinions />,
        document.getElementById('js-post-gay-marriage-changing-opinions'),
    );
}
